import removeExcessCharacters from './removeExcessCharacters';
const getStandardCannedReportParameters = function () {
    const params = {};
    // Old params presenter
    $('table.settings tbody tr').each(function () {
        const label = removeExcessCharacters($(this).children().first().text()), valueCell = $(this).children().last().clone();
        let value = valueCell.html(valueCell.html().replace(/<br[^>]*>/gi, ', ')).text();
        value = removeExcessCharacters(value);
        params[label] = value;
    });
    // CUPA-HR custom report style params presenter
    // Todo: this does not preserve the "correct" order of the params, and needs group size and positions added.
    // - For now the old params presenter is used, but hidden from the user.
    // $('.report-params > div').each(function () {
    //   function searchDivForParams(div) {
    //     let found = false;
    //     div.children().each(function () {
    //       if (found) return; // Exit if already found
    //       const $this = $(this);
    //       if ($this.hasClass('text-sm')) {
    //         let label = removeExcessCharacters($this.text());
    //         label = label
    //           .toLowerCase()
    //           .split(' ')
    //           .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    //           .join(' ');
    //         let value = removeExcessCharacters($this.next('.text-lg, .text-bold').text());
    //         value = removeExcessCharacters(value);
    //         if (label && value) {
    //           params[label] = value;
    //         }
    //         found = true;
    //       }
    //       searchDivForParams($this);
    //     });
    //   }
    //   searchDivForParams($(this));
    // });
    // Monocle params presenter for clients who have switched
    $('.canned-report-params ul li').each(function () {
        function searchForParams(el) {
            const $this = $(el);
            if ($this.hasClass('report-params-group')) {
                $this.find('li').each(function () {
                    searchForParams(this);
                });
            }
            else {
                let label = $this.find('.report-params-label').text();
                label = removeExcessCharacters(label);
                label = label
                    .toLowerCase()
                    .split(' ')
                    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                    .join(' ');
                let value = $this.find('.report-params-value').text();
                value = removeExcessCharacters(value);
                if (label && value) {
                    params[label] = value;
                }
            }
        }
        searchForParams(this);
    });
    return params;
};
export default getStandardCannedReportParameters;
